import React from "react";

const BankIcon = props => (
  <svg style={props.style} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 33.0875V18.1625" stroke={props.color} strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.5 33.0875V18.1625" stroke={props.color} strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5 33.0875V18.1625" stroke={props.color} strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M27.5 33.0875V18.1625" stroke={props.color} strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M35 33.0875V18.1625" stroke={props.color} strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M38.75 17.5H1.25L20.025 1.25L38.75 17.5Z" stroke={props.color} strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M38.75 33.75H1.25V38.75H38.75V33.75Z" stroke={props.color} strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default BankIcon;



// WEBPACK FOOTER //
// ./src/icons/BankIcon.jsx